import React from 'react';
import PropTypes from 'prop-types';
import Vault from './Button-Vault.svg';
import './VaultButton.css';

export const VaultButton = ({ onClick, className }) => {
  return (
    <div className={`vault-button-container ${className || ''}`}>
      <button type="button" className="vault-button" onClick={onClick}>
        <img src={Vault} alt="View Vault" />
      </button>
      <span className="vault-button-label">Vault</span>
    </div>
  );
};

VaultButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
